import { Injectable } from "@angular/core";
import { E_Patient_Actions_Type } from "@backend/graph/patient_actions/patient-action-base";
import { PatientActionsEntry } from "@apps/patient-core/src/app/data_model/patient-actions";
import { BasePatientActionsService } from "@apps/patient-core/src/app/services/abstracts/patient-actions.service";

export interface I_PatientActions_SessionStorage {
  actions: Array<PatientActionsEntry>;
  expiry?: number;
}

export function PATIENT_ACTIONS_QUERY() {
  return `{
  patient_actions {
    items {
      appointment_ids
      text
      type
      pms_action_type
      required
      data {
        meta_data {
          medical_history_id
          exemption_id
          patient_exemption_code
          form_type
          treatment_plans {
            total_cost
          }
          smile_goal {
            goal
            timeframe
            motivation
          }
        }
        patient_details_missing_data {
          sections
          fields
        }
        patient_details_completed_percentage
        routine_appt_data {
          site_id
          id
          is_nhs
          category_id
          appointment_name
          appointment_type_id
        }
        estimates {
          id
          template_name
        }
      }
    }
  }
}`;
}

@Injectable({
  providedIn: "root",
})
export class ConciergePatientActionsService extends BasePatientActionsService {
  protected getPatientActionsQuery(): string {
    return PATIENT_ACTIONS_QUERY();
  }

  public navigateToAction(action: PatientActionsEntry) {
    switch (action.type) {
      case E_Patient_Actions_Type.NHS_PR:
        this._handleNhsPrAction(action);
        break;
      case E_Patient_Actions_Type.MEDICAL_HISTORY:
        this._goToFormPage("my-dental/medical-history/update-medical-history");
        break;
      case E_Patient_Actions_Type.TREATMENT_PLAN_ESTIMATE:
        this._navigateToTreatmentPlanEstimate(action);
        break;
      case E_Patient_Actions_Type.PATIENT_DETAILS:
        this._handlePatientDetailsAction(action);
        break;
      default:
        break;
    }
  }
}
